import { useEffect, useState } from "react";
import { useGastos } from "../../../contexto/provider/GastosContext.js";

import TituloModulo from "../../../componentsUI/estructura/tituloModulos/tituloModulo.js";
import BotonAccion from "../../../componentsUI/formularios/button/BotonAction.js";
import GastosCard from "../gastosCard/gastosCard.js";


export default function ListaGastos() {
  const { listarGastos, loading, error } = useGastos();
  const [gastos, setGastos] = useState([]);
  const [abiertaId, setAbiertaId] = useState(null);

  useEffect(() => {
    const cargar = async () => {
    };
    cargar();
  }, [ listarGastos]);

  useEffect(() => {
  const cargar = async () => {
    const data = await listarGastos();
        console.log("[ListaGastos] data completa:", data);
    setGastos(data);
  };
  cargar();
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, []);

  const toggleGasto = (id) => {
    setAbiertaId((prev) => (prev === id ? null : id));
  };

  if (loading) return <p>Cargando gastos...</p>;
  if (error) return <p>Error: {error}</p>;

  return (
    <div>
      <TituloModulo titulo="Panel de gastos" />
      <BotonAccion onClick={() => listarGastos({ fuerza: true })}>
        Cargar
      </BotonAccion>

      <div className="contenedor-lista">
        {gastos.length === 0 ? (
          <p>No hay gastos registrados</p>
        ) : (
          gastos.map((gasto) => (
            <GastosCard
              key={gasto.id_gasto}
              gasto={gasto}
              abierta={abiertaId === gasto.id_gasto}
              onToggle={() => toggleGasto(gasto.id_gasto)}
            />
          ))
        )}
      </div>
    </div>
  );
}
